export default __webpack_public_path__ + "static/media/question-mark.51f8b9ff.svg";